import React from 'react';
import { BadgeProps } from './types';
import { StyledBadge } from './styles';
import { BadgeStatus, BadgeTone } from './enums';

const statusToTone: Record<BadgeStatus, BadgeTone> = {
  [BadgeStatus.Success]: BadgeTone.Success,
  [BadgeStatus.Error]: BadgeTone.Danger,
  [BadgeStatus.Info]: BadgeTone.Info,
};

const DOT_COLOR: Record<BadgeTone, string> = {
  [BadgeTone.Neutral]: 'var(--muted)',
  [BadgeTone.Success]: 'var(--success-indicator)',
  [BadgeTone.Warning]: 'var(--warning)',
  [BadgeTone.Danger]:  'var(--danger)',
  [BadgeTone.Info]:    'var(--info)',
  [BadgeTone.Ink]:     'var(--brand-lime)',
};

const Badge: React.FC<BadgeProps> = ({
  status,
  tone: toneProp,
  isRound,
  dot,
  children,
}) => {
  const resolvedTone =
    toneProp ??
    (status ? statusToTone[status] : BadgeTone.Neutral);
  const textVariant = isRound ? 'bodyBold' : 'caption';

  return (
    <StyledBadge {...{ isRound, resolvedTone }} variant={textVariant}>
      {dot && (
        <span
          style={{
            width: 6,
            height: 6,
            borderRadius: '50%',
            background: DOT_COLOR[resolvedTone],
            flexShrink: 0,
            display: 'inline-block',
          }}
        />
      )}
      {children}
    </StyledBadge>
  );
};

export default Badge;
